<template>
	<form class="full-width column flexible" @submit="submitForm">
		<header class="row centering separated">
			<h1 class="rigid capitalize">Setup Payment Method</h1>
		</header>

		<div class="column panel relative">
			<div v-if="paymentMethod" class="current badge badge-muted row separated">
				<span class="rigid">Current:</span>
				<span class="rigid">
					<i class="fab" :class="'fa-cc-' + paymentMethod.brand.toLowerCase()"></i>
					{{paymentMethod.last4}}
				</span>
			</div>
			<div>
				<div class="field">
					<!-- <div class="row"> -->
						<label for="stripeElement" class="label flexible required">Credit Card</label>

					<!-- </div> -->
					<section class="stripe-element">
						<stripe-card :reset-stripe="reset" id="stripeElement" v-on:create-token="setCardData"></stripe-card>
					</section>
				</div>
			</div>

			<div v-if="addMethodError" class="row">
				<div class="notice error flexible"><p>{{addMethodError.message || addMethodError.type}}</p>
				<p>Please try again or <a :href="'mailto:' + supportEmail + '?subject=Add%20Payment%20Method%20Error'">contact support</a>.</p>
				</div>
			</div>
		</div>
        <footer class="row separated right centering">
			<a v-if="navigation.start.view" class="link rigid" :href="navigation.start.view"><small><i class="fas fa-arrow-left"></i></small> {{navigation.start.name}}</a>
			<span class="gap"></span>
			<button v-if="paymentMethod" @click="next()" type="button">Use Current</button>
            <submit-button type="submit" class="primary rigid" :button-text="'Continue'" :submitting-text="'Adding Card'" :is-submitting="submitting" :is-disabled="!tokenId || submitting"></submit-button>
		</footer>
	</form>
</template>

<script>
import StripeCard from '@/components/StripeCard';
import SubmitButton from '@/components/SubmitButton';
import { mapGetters } from 'vuex';
import { default as ENV_VARS } from '@/modules/env-vars.js';

export default {
	name: 'PaymentMethod',
	components:{
		StripeCard,
		SubmitButton,
	},
	props: {
		navigation: Object
	},
	data(){
		return {
			reset: false,
			tokenId: null,
			submitting: false,
			paymentMethodAdded: false,
			addMethodError: null
		};
	},
	computed:{
		...mapGetters([
			'user',
			'account',
			'accountStatus',
			'userStatus'
		]),
		supportEmail(){
			return ENV_VARS.SUPPORT_EMAIL;
		},
		returnPath(){
			return this.$route.query.returnPath || '/payments';
		},
		paymentMethod() {
			return this.account && this.account.paymentMethod;
		}
	},
	methods:{
		unsupportedCountry(country){
			return !this.supportedCountries.includes(country);
		},
		setCardData(result) {
			if (result && result.token && result.token.card) {
				this.card = {
					last4: result.token.card.last4,
					brand: result.token.card.brand
				};
			}
			this.tokenId = result && result.token && result.token.id;
		},
		onAddressChange(val){
			this.address = val;
		},
		next() {
			this.$emit('navigation', this.navigation.currentIndex + 1);
		},
		back() {
			this.$emit('navigation', this.navigation.currentIndex - 1);
		},
		submitForm(e){
			e.preventDefault();
			let vm = this;
			vm.submitting = true;

			this.addPaymentMethod()
				.then(response => {
					vm.next();
				})
				.catch(reason => {
					vm.addMethodError = reason;
				})
				.finally(()=>{
					vm.submitting = false;
				});
		},
		addPaymentMethod(e) {
			return this.$store.dispatch('payment/ADD_PAYMENT_REQUEST', {
				type: 'stripe',
				token: this.tokenId
			});
		}
	},
	mounted() {
		this.reset = true;
	}
};
</script>

<style scoped>
.panel {
	background: white;
	border-radius: 6px;
	padding: 2rem;
	border: 2px solid #dfdfdf;
	width: 100%;
	margin: auto;
	box-sizing: border-box;
}
.dark .panel {
	background: #1a1a1a;
	border: 2px solid #333;
}

.current i {
	margin-right: 4px;
}

.current.badge {
	position: absolute;
    top: 0;
    right: 0;
    left: auto;
	padding: .8em;
	border-top-left-radius: 0;
	border-bottom-right-radius: 0;
}

label.required:after {
	content: ' *';
}

.panel + footer {
	margin-top: 2em;
}

</style>



// WEBPACK FOOTER //
// ./src/views/promotions/PaymentMethod.vue